import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { ConfigProvider, Drawer, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { getProduct, getThread } from "../redux/selectors";
import { summaryService } from "../api";

const ViewersTable: React.FC = () => {
  const [open, setOpen] = useState(false);
  const feedFilter = useSelector(getFeedFilter);
  const [loading, setLoading] = useState(true);
  const [cities, setCities] = useState([]);
  const product = useSelector(getProduct);
  const thread = useSelector(getThread);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    if (thread) {
      let params = {
        product_id: product,
        from: feedFilter.from.slice(0, 10) + " 00:00:00",
        to: feedFilter.to.slice(0, 10) + " 23:59:59",
      };
      summaryService
        .loadProductCityListReverse(params)
        .then((resp) => {
          setCities(resp);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [thread, feedFilter, product]);

  cities?.map((city) => console.log("city", city));

  const data: any = [];
  cities
    ?.sort((a: any, b: any) => (a.rating < b.rating ? 1 : -1))
    .map((city: any, id: number) => {
      data.push({
        key: id + 1,
        title: city.city,
        rating: city.rating,
        posts: city.posts,
      });
    });

  const columns = [
    {
      title: "№",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "Город",
      dataIndex: "title",
      key: "title",
    },
    {
      title: (
        <Tooltip
          color={"#7856FE"}
          title="Рейтинг - показатель активности аудитории из данного города, рассчитываемый на основе лайков/репостов/комментариев под постами"
        >
          <div>
            Рейтинг
            <InfoCircleOutlined className="info" />
          </div>
        </Tooltip>
      ),
      dataIndex: "rating",
      key: "rating",
    },
  ];

  return (
    <div className="white-block">
      <div className="flex-space">
        <div>
          <p className="block-title">
            Геолокация по просмотрам
            <InfoCircleOutlined className="info" onClick={showDrawer} />
          </p>
        </div>
      </div>
      {loading ? (
        <div className="feed-posts-loader">
          <LoadingOutlined />
        </div>
      ) : (
        <ConfigProvider
          theme={{
            components: {
              Table: {
                cellPaddingBlock: 12,
              },
            },
          }}
        >
          <Table
            className="big-table"
            bordered={false}
            dataSource={data}
            columns={columns}
            pagination={false}
          />
        </ConfigProvider>
      )}
      <Drawer title="Что отображает этот график?" onClose={onClose} open={open}>
        <p className="purple-border">
          Демонстрирует статистику просмотров к публикациям с упоминаниями
          компании в зависимости от геолокации аудитории
        </p>
        <p className="gray-block">
          <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в реальном
          времени, что позволяет вам следить за актуальными трендами и реакцией
          аудитории на ваш контент
        </p>
      </Drawer>
    </div>
  );
};

export default ViewersTable;
